import { z } from 'zod';
import { msObject } from '../resource-base/msObject';

const PropertyDetailsResourceSchema = msObject({
    propertyName: z.string(),
    displayName: z.string(),
    description: z.string(),
    updatable: z.boolean(),
    isFunctional: z.boolean(),
    isBusinessProperty: z.boolean(),
    persistableTypeFilter: z
        .string()
        .array()
        .nullable(),
});

export type PropertyDetailsResource = z.infer<typeof PropertyDetailsResourceSchema>;

export const PropertyDetailsPayloadSchema = msObject({
    persistableTypeGroup: z.string(),
    propertyDetails: z.record(z.string(), PropertyDetailsResourceSchema),
});

export type PropertyDetailsPayload = z.infer<typeof PropertyDetailsPayloadSchema>;
